// src/components/ZoneTemplatesDialog.tsx - FIXED VERSION
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  Box
} from '@mui/material';
import api from '../services/api';

interface Template {
  id: string;
  name: string;
  description: string;
  type: string;
  rules: any;
  color: string;
}

interface ZoneTemplatesDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (template: Template) => void;
}

const ZoneTemplatesDialog: React.FC<ZoneTemplatesDialogProps> = ({
  open,
  onClose,
  onSelect
}) => {
  const [templates, setTemplates] = useState<Template[]>([]);

  useEffect(() => {
    if (open) {
      fetchTemplates();
    }
  }, [open]);

  const fetchTemplates = async () => {
    try {
      const response = await api.get('/geofencing/templates');
      setTemplates(response.data.data);
    } catch (error) {
      console.error('Error fetching templates:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Select Zone Template</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {templates.map((template) => (
            <Grid item xs={12} sm={6} md={4} key={template.id}>
              <Card 
                sx={{ 
                  cursor: 'pointer',
                  borderLeft: 4,
                  borderColor: template.color,
                  '&:hover': {
                    boxShadow: 6
                  }
                }}
                onClick={() => onSelect(template)}
              >
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {template.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {template.description}
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    <Chip size="small" label={template.type} />
                    {template.rules.speedLimit && (
                      <Chip size="small" label={`${template.rules.speedLimit} km/h`} />
                    )}
                    {!template.rules.allowEntry && (
                      <Chip size="small" label="Restricted Entry" color="error" />
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ZoneTemplatesDialog;